import { render, staticRenderFns } from "./UploadProdutoManutencao.vue?vue&type=template&id=2fba8f06&scoped=true&"
import script from "./UploadProdutoManutencao.vue?vue&type=script&lang=js&"
export * from "./UploadProdutoManutencao.vue?vue&type=script&lang=js&"
import style0 from "./UploadProdutoManutencao.vue?vue&type=style&index=0&id=2fba8f06&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fba8f06",
  null
  
)

export default component.exports